import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BaseIcon from './components/BaseIcon.vue'
import BaseReload from './components/BaseReload.vue'

import VueAnalytics from 'vue-analytics'
import vueDebounce from 'vue-debounce'

import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

import './plugins'

Vue.config.productionTip = false

Vue.component('base-icon', BaseIcon)
Vue.component('base-reload', BaseReload)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)

const VUE_APP_ENV = process.env.VUE_APP_ENV

const isProd = VUE_APP_ENV === 'production'

Vue.config.ignoredElements = ['menu-global', 'menu-sidebar', 'menu-tour']

Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA,
  checkDuplicatedScript: true,
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd,
  },
})

Vue.use(vueDebounce)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
